import * as React from 'react';
import {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import Table from "../../Table";
import {addClientToTherapySession, deleteClientToTherapySession, getClients, getTherapySession} from "../../../api";
import {Client, TherapySession} from "../../../types";
import dateFormat from "dateformat";
import {useHistory} from "react-router";

var format = require('date-format');


const AddClientTherapySession: React.FunctionComponent = () => {

        const [clients, setClients] = useState<Client[]>();
        const [clientsInSession, setClientsInSession] = useState<Client[]>([])
        const [firstName, setFirstName] = useState("");
        const [lastName, setLastName] = useState("");
        const [email, setEmail] = useState("");
        const [clientId, setClientId] = useState("");
        const [disabled, setDisabled] = useState("false");
        const [doRedirectToSearch, setDoRedirectToSearch] = useState(false);
        const [therapySession, setTherapySession] = useState<TherapySession>();
    const [selectedClientId, setSelectedClientId] = useState("");

        const history = useHistory();
        const {id} = useParams();

        useEffect(() => {

            getTherapySession(id)
                .then((t) => {
                    setTherapySession(t);
                })
                .catch((e) => {
                    console.log(e)
                })
        }, [])

        useEffect(() => {
            if (doRedirectToSearch) {
                history.push({
                    pathname: "/m/therapy-sessions/view/" + id
                });
            }
        }, [doRedirectToSearch, history, id]);

        useEffect(() => {
            loadData();
        }, []);

        function loadData() {
            getClients(clientId, firstName, lastName, email, disabled, "")
                .then((c) => {
                    setClients(c);
                    getClients("", "", "", "", "false", id)
                        .then((c) => {
                            setClientsInSession(c);
                        })
                        .catch((e) => {
                            console.log(e);
                        })
                        .finally(() => setSelectedClientId(""));
                })
                .catch((e) => {
                    console.log(e);
                })



        }

        const doAdd = (clientId: string) => {
            setSelectedClientId(clientId);
            addClientToTherapySession(id, clientId)
                .then((r) => {
                    loadData();
                })
                .catch((e) => {
                    console.log(e);
                })
        }

        function isClientInSession(clientId: string) {
            if (clientsInSession) {
                let result = clientsInSession.filter(c => c.uuid === clientId);
                if (result && result.length > 0) {
                    return true;
                }
            }
            return false;
        }

        function doRemove(clientId: string) {
            setSelectedClientId(clientId)
            deleteClientToTherapySession(id, clientId)
                .then((r) => {
                    loadData();
                })
                .catch(e => console.error(e.message))
        }

        function getLoadingSpinner(clientId: string) {
            if(clientId === selectedClientId) {
                return <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            }
        }

        function getButton(clientId: string) {
            if (isClientInSession(clientId)) {
                return <button type={"button"} className={"btn btn-sm btn-danger"}
                               onClick={(e) => {
                                   e.preventDefault();
                                   doRemove(clientId)
                               }}>
                    {getLoadingSpinner(clientId)}
                    Remove
                </button>
            }
            return <button type={"button"} className={"btn btn-sm btn-primary"}
                           onClick={(e) => {
                               e.preventDefault();
                               doAdd(clientId);
                           }}>
                {getLoadingSpinner(clientId)}
                Add
            </button>
        }

        return ((therapySession !== undefined) ? <>
            <form onSubmit={(e) => {
                e.preventDefault();
                loadData();
            }}>
                <div className={"row"}>
                    <div className={"col-lg-12 mb-3 "}>
                        <h2>Add Client to Therapy Session
                            on {dateFormat(format.parse("yyyy-MM-dd", therapySession.date), "mm/dd/yyyy")}</h2>
                    </div>

                    <div className={"col-lg-12 mb-3 "}>
                        <div className="form-row align-items-center">
                            <div className="col-sm-1 my-1">
                                <label className="sr-only" htmlFor="inlineFormInputName">ID</label>
                                <input type="text" className="form-control" id="inlineFormInputName"
                                       placeholder={"ID"} autoComplete={"new-password"}
                                       value={clientId} onChange={(e) => setClientId(e.target.value)}/>
                            </div>
                            <div className="col-sm-2 my-1">
                                <label className="sr-only" htmlFor="inlineFormInputName">First Name</label>
                                <input type="text" className="form-control" id="inlineFormInputName"
                                       placeholder={"First Name"} autoComplete={"new-password"}
                                       value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
                            </div>
                            <div className="col-sm-2 my-1">
                                <label className="sr-only" htmlFor="inlineFormInputName">Last Name</label>
                                <input type="text" className="form-control" id="inlineFormInputName"
                                       placeholder={"Last Name"} autoComplete={"new-password"}
                                       value={lastName} onChange={(e) => setLastName(e.target.value)}/>
                            </div>
                            <div className="col-sm-2 my-1">
                                <label className="sr-only" htmlFor="inlineFormInputName">Email</label>
                                <input type="text" className="form-control" id="inlineFormInputName"
                                       placeholder={"Email"}
                                       autoComplete={"new-password"}
                                       value={email} onChange={(e) => setEmail(e.target.value)}/>
                            </div>
                            <div className="col-auto my-1">
                                <button type="submit" className="btn btn-primary">Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <Table headers={["ID", "First Name", "Last Name", "Email", "SSN", "Assessment Date"]}
                           defaultPaginationSize={100}>
                        {
                            clients?.map((c) => (
                                <tr key={c.uuid}>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.id}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.firstName}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={"/m/clients/view/" + c.uuid}>
                                            {c.lastName}
                                        </Link>
                                    </td>
                                    <td>{c.email}</td>
                                    <td>{c.socialsecurityNumber}</td>
                                    <td>{(c.dateTimeofAssessment !== undefined) ? dateFormat(format.parse("yyyy-MM-ddThh:mm:ss", c.dateTimeofAssessment), "yyyy/mm/dd, h:MM:ss TT") : ""}</td>
                                    <td>
                                        {getButton(c.uuid)}
                                    </td>
                                </tr>
                            ))
                        }

                    </Table>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/therapy-sessions/view/" + id}>
                        <button type={"button"} className={"btn btn-danger mr-3"}>
                            Done
                        </button>
                    </Link>

                </div>

            </div>
        </> : <></>)
            ;
    }
;

export default AddClientTherapySession;